import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CountryList from './CountryList';
import RootModal from './RootModal';

let timer = null;

export default class FlagDropDown extends Component {
  static propTypes = {
    allowDropdown: PropTypes.bool,
    dropdownContainer: PropTypes.string,
    separateDialCode: PropTypes.bool,
    dialCode: PropTypes.string,
    countryCode: PropTypes.string,
    showDropdown: PropTypes.bool,
    clickSelectedFlag: PropTypes.func,
    handleSelectedFlagKeydown: PropTypes.func,
    isMobile: PropTypes.bool,
    setFlag: PropTypes.func,
    countries: PropTypes.arrayOf(PropTypes.object),
    inputTop: PropTypes.number,
    inputOuterHeight: PropTypes.number,
    preferredCountries: PropTypes.arrayOf(PropTypes.object),
    highlightedCountry: PropTypes.number,
    changeHighlightCountry: PropTypes.func,
    titleTip: PropTypes.string,
    refCallback: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
    };
  }

  genSelectedDialCode = () => {
    const { separateDialCode, dialCode } = this.props;

    return separateDialCode ? <div className="selected-dial-code">{dialCode}</div> : null;
  };

  genArrow = () => {
    const { allowDropdown, showDropdown } = this.props;
    const arrowClasses = classNames('arrow', showDropdown ? 'up' : 'down');

    return allowDropdown ? <div className={arrowClasses} /> : null;
  };

  genFlagClassName = () =>
    classNames('iti-flag', {
      [this.props.countryCode]: !!this.props.countryCode,
    });

  handleSearch = (e) => {
    if (timer) clearTimeout(timer);
    const { value } = e.target;
    this.setState({ searchText: value });

    this.props.searchForCountry(value.toUpperCase());
    timer = setTimeout(() => {
      e.target.value = '';
    }, 1000);
  };

  genCountryList = () => {
    const {
      dropdownContainer,
      showDropdown,
      allowDropdown,
      setFlag,
      countries,
      inputTop,
      inputOuterHeight,
      preferredCountries,
      highlightedCountry,
      changeHighlightCountry,
    } = this.props;

    return (
      <CountryList
        ref={(countryList) => {
          this.countryList = countryList;
        }}
        dropdownContainer={dropdownContainer}
        showDropdown={allowDropdown && showDropdown}
        setFlag={setFlag}
        countries={countries}
        inputTop={inputTop}
        inputOuterHeight={inputOuterHeight}
        preferredCountries={preferredCountries}
        highlightedCountry={highlightedCountry}
        changeHighlightCountry={changeHighlightCountry}
      />
    );
  };

  render() {
    const {
      refCallback,
      allowDropdown,
      clickSelectedFlag,
      titleTip,
      dropdownContainer,
      showDropdown,
      isMobile,
    } = this.props;

    return (
      <>
        {isMobile && showDropdown && (
          <input autoFocus onChange={this.handleSearch} className="selected-flag-input" />
        )}

        <div ref={refCallback} className="flag-container">
          <div
            role="flag-selector"
            className="selected-flag"
            tabIndex={allowDropdown ? '0' : ''}
            onClick={(e) => {
              clickSelectedFlag(e);
              e.preventDefault();
            }}
            title={titleTip}
          >
            <div className={this.genFlagClassName()} />
            {this.genSelectedDialCode()}
            {this.genArrow()}
          </div>
          {dropdownContainer && showDropdown ? (
            <RootModal>{this.genCountryList()}</RootModal>
          ) : (
            this.genCountryList()
          )}
        </div>
      </>
    );
  }
}
